import React, { useEffect, useMemo, useState } from "react";
import { LayoutFooter, LayoutFooterProps } from "@/componentsUI/Layout";
import cs from "classnames";
import styles from "./style/index.module.less";
import { detectClientEnvironment } from "@/features/clientEnv";
import { useTranslationPlus } from "@/Core/i18n/useTranslationPlus";

function Footer(props: LayoutFooterProps = {}) {
  const { className, ...restProps } = props;
  const { t } = useTranslationPlus();
  const clientEnv = detectClientEnvironment();
  const isAppWebView = clientEnv.isNativeWebView || clientEnv.isFlutterWebView;
  const [buildTime, setBuildTime] = useState<string | null>(null);

  useEffect(() => {
    let mounted = true;
    fetch("/build-info.json")
      .then((res) => (res.ok ? res.json() : null))
      .then((info) => {
        if (!mounted || !info?.buildTime) {
          return;
        }
        const time = new Date(info.buildTime);
        if (Number.isNaN(time.getTime())) {
          return;
        }
        const formatted = new Intl.DateTimeFormat(undefined, {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        }).format(time);
        setBuildTime(formatted);
      })
      .catch(() => null);

    return () => {
      mounted = false;
    };
  }, []);

  const buildTimeText = useMemo(() => {
    if (!buildTime) {
      return null;
    }
    return `BuildTime: ${buildTime}`;
  }, [buildTime, t]);

  return (
    <LayoutFooter
      className={cs(styles.footer, className)}
      {...restProps}
      style={{ paddingBottom: isAppWebView ? "80px" : 60 }}
    >
      <div className={styles.footerContent}>
        {props.children}
        {buildTimeText && (
          <div className={styles.buildTime}>{buildTimeText}</div>
        )}
      </div>
    </LayoutFooter>
  );
}

export default Footer;
